import { render, staticRenderFns } from "./FaceImage.vue?vue&type=template&id=3cff3e2c&"
import script from "./FaceImage.vue?vue&type=script&lang=ts&"
export * from "./FaceImage.vue?vue&type=script&lang=ts&"
import style0 from "./FaceImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports